<template>
  <div style="padding: 10px; height: 100%">
    <div v-if="compshow" class="t_outbox">
      <div class="t_step_box">
        <div class="t_title">库存初始化流程</div>
        <el-steps class="t_step" :active="4" align-center>
          <el-step title="从业人员" @click.native="cyry" />
          <el-step title="往来单位" @click.native="wldw" />
          <el-step title="仓库管理" @click.native="ckgl" />
          <el-step title="库存初始化" @click.native="kccsh" />
        </el-steps>
      </div>
    </div>
    <div v-if="!compshow" class="t_comp_box">
      <!-- 从业人员 -->
      <cyry1 v-if="cyry1show" />
      <!-- 往来单位 -->
      <WlCompany v-if="WlCompanyshow" />
      <!-- 仓库管理 -->
      <ckManage v-if="ckManageshow" />
      <!-- 库存初始化 -->
      <KCinitialize v-if="KCinitializeshow" :lc="lc" />
      <div style="text-align: center; margin-top: 20px; padding-bottom: 20px">
        <el-button
          v-preventReClick
          style="
            background-color: #4170ff !important;
            color: white;
            border: none;
          "
          type="primary"
          @click="back"
        >返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 获取接口地址
import cyry1 from '@/components/cyry'
import WlCompany from '../components/wlCompany/wlCompany.vue'
import ckManage from '@/components/Warehouse/ckManage'
import KCinitialize from '@/components/Kccsh/KCinitialize'

export default {
  name: 'Kccshlc',
  components: {
    cyry1,
    WlCompany,
    ckManage,
    KCinitialize
  },
  data() {
    return {
      compshow: true,
      cyry1show: false,
      WlCompany: false,
      ckManage: false,
      KCinitialize: false,
      lc: 1
    }
  },
  created: function() {},
  methods: {
    // 从业人员
    cyry() {
      this.compshow = false
      this.cyry1show = true
      this.WlCompanyshow = false
      this.ckManageshow = false
      this.KCinitializeshow = false
    },
    // 往来单位
    wldw() {
      this.compshow = false
      this.cyry1show = false
      this.WlCompanyshow = true
      this.ckManageshow = false
      this.KCinitializeshow = false
    },
    // 仓库管理
    ckgl() {
      this.compshow = false
      this.cyry1show = false
      this.WlCompanyshow = false
      this.ckManageshow = true
      this.KCinitializeshow = false
    },
    // 库存初始化
    kccsh() {
      this.compshow = false
      this.cyry1show = false
      this.WlCompanyshow = false
      this.ckManageshow = false
      this.KCinitializeshow = true
    },
    // 返回流程
    back() {
      this.compshow = true
      this.cyry1show = false
      this.WlCompanyshow = false
      this.ckManageshow = false
      this.KCinitializeshow = false
    }
  }
}
</script>

<style scoped lang='less'>
.t_outbox {
  width: 90%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.t_step_box {
  /* border:1px solid red; */
  width: 90%;
}
.t_title {
  font-size: 24px;
  margin-bottom: 50px;
  text-align: center;
}
/deep/.el-step__title {
  cursor: pointer;
}
</style>
